"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DmsButton = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Button = _interopRequireDefault(require("@mui/material/Button"));
var _IconButton = _interopRequireDefault(require("@mui/material/IconButton"));
var _Tooltip = _interopRequireDefault(require("@mui/material/Tooltip"));
var _pollux_dms = require("../../pollux_dms");
var _DmsDoubleBlind = require("../DmsDoubleBlind/DmsDoubleBlind");
var _index = require("../../index");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
/*
 * Description: This component gives you a generic button
 * Props:
 * - children: Children that will be added inside the button
 * - variant: Bootstrap variant of the component (primary, secondary, success, danger, warning, info, light, dark, link)
 * - text: Text that will be shown to the user
 * - icon: Icon that will be shown to the user
 * - onClick: Function that will be called when the user clicks on the button
 * - label: Label that will be shown used for the button
 * - disabled: If the button is disabled or not
 * - outline: If the button is an outline button or not
 * - iconFirst: If the icon should be placed before the text or not
 * - isDoubleBlind: If true, pops up double blind
 * - doubleBlindHeaderText: Text to be used on double blind header
 * - title: Tooltip text that will be shown on hover (especially useful for icon-only buttons)
 */

const colorMapping = {
  primary: "primary",
  secondary: "secondary",
  success: "success",
  danger: "error",
  warning: "warning",
  info: "info",
  light: "inherit",
  dark: "inherit",
  link: "inherit"
};
const variantMapping = {
  primary: "contained",
  secondary: "contained",
  success: "contained",
  danger: "contained",
  warning: "contained",
  info: "contained",
  light: "outlined",
  dark: "contained",
  link: "text"
};
const DmsButton = _ref => {
  let {
    variant = "primary",
    type = "button",
    outline = false,
    disabled = false,
    iconFirst = false,
    label,
    icon,
    text,
    children,
    onClick,
    isDoubleBlind,
    doubleBlindHeaderText,
    style,
    title
  } = _ref;
  const [trigger, setTrigger] = (0, _react.useState)(false);
  const button_key = "dmsButton_" + (0, _pollux_dms.generate_random_id)();
  const buttonVariant = outline ? "outlined" : variantMapping[variant] || "contained";
  const buttonColor = colorMapping[variant] || "primary";
  const isIconOnly = !text && !children;
  const handleClick = async e => {
    if (isDoubleBlind) {
      setTrigger(true);
      return;
    }
    let targetElement = e.target;

    // Traverse up the DOM tree to find the button element
    while (targetElement && targetElement.getAttribute("data-dms-button-group") !== button_key) {
      targetElement = targetElement.parentElement;
    }
    if (targetElement) {
      if (onClick) await onClick(e);
    }
  };
  const iconOnlyButton = /*#__PURE__*/_react.default.createElement(_IconButton.default, {
    style: style,
    type: type,
    "aria-label": label || title,
    color: buttonColor,
    onClick: handleClick,
    disabled: disabled,
    "data-dms-button-group": button_key
  }, icon);
  const regularButton = /*#__PURE__*/_react.default.createElement(_Button.default, {
    style: style,
    type: type,
    "aria-label": label,
    variant: buttonVariant,
    color: buttonColor,
    onClick: handleClick,
    disabled: disabled,
    "data-dms-button-group": button_key,
    startIcon: iconFirst ? icon : null,
    endIcon: !iconFirst ? icon : null
  }, text, children);
  const buttonElement = isIconOnly ? iconOnlyButton : regularButton;

  // Wrap with Tooltip if title is provided
  const wrappedButton = title ? /*#__PURE__*/_react.default.createElement(_Tooltip.default, {
    title: title
  }, disabled ? /*#__PURE__*/_react.default.createElement("span", null, buttonElement) : buttonElement) : buttonElement;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, wrappedButton, isDoubleBlind && /*#__PURE__*/_react.default.createElement(_DmsDoubleBlind.DmsDoubleBlind, {
    show: trigger,
    setShowDoubleBlind: setTrigger,
    onSuccess: onClick,
    onClose: () => setTrigger(false),
    headerText: doubleBlindHeaderText || _index.intl.get('DoubleBlindHeader').d('Double Blind Authentication')
  }));
};
exports.DmsButton = DmsButton;